import { Flow } from '@/components/Flow';
import { ThemeProvider } from '@mui/material/styles';
import { baseTheme } from './config/themes/base-theme';
import { CssBaseline } from '@mui/material';
import { AppHeader } from '@/components/AppHeader';
import { useBranding } from './hooks/use-branding';
import { useEffect } from 'react';
import { ModalProvider } from './contexts/modal/modal-provider';
import { TabListProvider } from './contexts/tabs/tab-list-provider';
import { ToastProvider } from './contexts/toasts/toast-provider';
import { useFlow } from './hooks/use-flow';
import { MobileAppHeader } from './components/MobileAppHeader';

export function App() {
  const { flowStatus, isRefreshing, sceneData, partnerBrandingConfig, errorData, errorStatus, init, submit, route } =
    useFlow();
  const { partnerTheme, setBranding, isPartnerThemeLoading } = useBranding();

  const shouldRenderPartnerTheme = !isPartnerThemeLoading && partnerTheme;
  const isMobileExperience = sceneData?.experience === 'mobile_customer_onboarding';

  useEffect(() => {
    if (flowStatus == 'initializing') {
      void init();
    }
  }, [flowStatus, init]);

  useEffect(() => {
    if (isPartnerThemeLoading && partnerBrandingConfig) {
      setBranding(partnerBrandingConfig);
    }
  }, [partnerBrandingConfig, setBranding, isPartnerThemeLoading]);

  return (
    <ThemeProvider theme={shouldRenderPartnerTheme ? partnerTheme : baseTheme}>
      <CssBaseline />
      <ModalProvider>
        <TabListProvider>
          <ToastProvider>
            {isMobileExperience ? (
              <MobileAppHeader />
            ) : (
              <AppHeader
                route={route}
                submit={submit}
                logoSrc={partnerBrandingConfig?.primary_logo_url}
                components={partnerBrandingConfig?.header_components ?? []}
                showHeader={partnerBrandingConfig?.show_header}
              />
            )}
            <Flow
              flowStatus={flowStatus}
              isRefreshing={isRefreshing}
              route={route}
              submit={submit}
              sceneData={sceneData}
              errorData={errorData}
              errorStatus={errorStatus}
            />
          </ToastProvider>
        </TabListProvider>
      </ModalProvider>
    </ThemeProvider>
  );
}
